import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { ValidationController, ValidationControllerFactory, ValidationRules } from "aurelia-validation";
import { Models } from "models/core";
import { ErrorService } from "services/error-service";
import { LocationCodeService } from "services/location-code-service";
import { ServiceConsumptionSewingThreadService } from "services/service-consumption-sewing-thread-service";
import { ServiceProductService } from "services/service-product-service";
import { SewingThreadTypeServiceService } from "services/sewing-thread-type-service-service";
import { ToastService } from "services/toast-service";

@autoinject
export class SewingThreadInlineEdit {
  @bindable private sewingThread: Models.ServiceConsumptionSewingThread;
  @bindable private editFormVisible;
  @bindable private service: Models.Service;

  private sewingThreadTypeServices: Models.SewingThreadTypeService[] = [];
  private validationController: ValidationController;

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private toastService: ToastService,
    private sewingThreadTypeServiceService: SewingThreadTypeServiceService,
    private serviceConsumptionSewingThreadService: ServiceConsumptionSewingThreadService,
    private t: I18N,
    validationControllerFactory: ValidationControllerFactory,
    private serviceProductservice: ServiceProductService,
    private locationCodeService: LocationCodeService
  ){
    this.validationController = validationControllerFactory.createForCurrentScope();
  }

  protected applyValidationRules(item: Models.ServiceConsumptionSewingThread) {
    ValidationRules.ensure('SewingThreadTypeServiceId')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Consumption')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .min(0)
      .withMessage(this.t.tr('validation.mustBeGreaterOrEqualToValue', { value: 0 }))
      .ensure('ProductionNumber')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .on(item);
  }

  private async validate(item: Models.ServiceConsumptionSewingThread) {
    this.applyValidationRules(item);
    return (await this.validationController.validate({ object: item })).valid;
  }

  protected attached() {
    void this.getSewingThreadTypeServices();
  }

  private async getSewingThreadTypeServices() {
    const result = await this.serviceProductservice.getSewingThreadTypesService('Repair', this.service.Id);
    this.sewingThreadTypeServices = result.data;
  }

  protected async saveSewingThread() {
    try {
      //removed expanded objects
      delete this.sewingThread.SewingThreadTypeService;
      delete this.sewingThread.LocationCode;    

      if (!(await this.validate(this.sewingThread))) return;
      this.sewingThread.LocationCodeId = this.sewingThread.LocationCodeId || null;

      await this.serviceConsumptionSewingThreadService.put(this.sewingThread, this.sewingThread.Id,);
      this.eventAggregator.publish('serviceConsumptionSewingThreadsListReset', 0);
      this.toastService.showSuccess('service.consumptionThreadSaved');
      this.editFormVisible = false;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

    protected cancel() {
    this.editFormVisible = null;
    this.eventAggregator.publish('serviceConsumptionSewingThreadsListReset', 0);
  }
}